import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../models/DataModel';
import './CloseoutNotificationBanner.scss';
import LocationsIconSolid from '../../Iconoclast/LocationsIconSolid';
import ReduxConstants from '../../../constants/ReduxConstants';
/**
 * <CloseoutNotificationBanner> - child component of <GlobalBanner>
 * Supports both Closeout and Progress Report notifications
 */
export default class CloseoutNotificationBanner extends React.Component {

  constructor(props) {
    super(props);
    CloseoutNotificationBanner.propTypes = {
      /** Name of the closeoutable (project, build, or task) to be displayed in the banner */
      closeoutableName: PropTypes.string.isRequired,
      /** Project id for the closeoutable - used for navigation (optional for projectTemplate) */
      locationId: PropTypes.number,
      /** Project id for the closeoutable - used for navigation (optional for projectTemplate) */
      projectId: PropTypes.number,
      /** ID of the closeout or progress report itself */
      closeoutId: PropTypes.number,
      /** ID of the progress report (used when documentType is 'progressReport') */
      progressReportId: PropTypes.number,
      /** Project type id - used when documentType is 'projectTemplate' */
      projectTypeId: PropTypes.number,
      /** Project template id - used when documentType is 'projectTemplate' */
      projectTemplateId: PropTypes.number,
      /** client data originally sent to closeout request */
      clientData: PropTypes.object,
      /** Type of document: 'closeout' (default), 'progressReport', or 'projectTemplate' */
      documentType: PropTypes.oneOf(['closeout', 'progressReport', 'projectTemplate']),
    };
    this.state = {
      shown: false,
    };

    this.analyticsLogger = new AnalyticsLogger({
      isMobile: !!window.cordova,
    });

    this.closeBanner = this.closeBanner.bind(this);
    this.navigateToDestination = this.navigateToDestination.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ shown: true });
    }, 0);
  }

  /** HELPERS */
  closeBanner() {
    return new Promise((resolve) => {
      this.setState({ shown: false });
      // wait for animation to actually close banner
      setTimeout(() => {
        resolve();
        // clear from local storage and hide the component
        dataModel.hideGlobalBanner(this.props.bannerType, true);
      }, 150);
    });
  }
  
  navigateToDestination() {
    const { locationId, projectId, closeoutId, clientData, documentType, projectTypeId, projectTemplateId } = this.props;

    if (documentType === 'projectTemplate') {
      this.analyticsLogger.logCloseoutNotification('ProjectTemplateVersionTopBanner');
      const uri = (projectTypeId != null && projectTemplateId != null)
        ? '/project-types/' + projectTypeId + '/project-template/' + projectTemplateId
        : '/project-types';
      this.closeBanner().then(() => dataModel.navigateUri = uri);
    }
    else if (documentType === 'progressReport') {
      this.analyticsLogger.logCloseoutNotification('ProgressReportDocumentTopBanner');
      // Navigate to project's Plan of Record with all locations, open Progress Reports tab
      this.closeBanner().then(() => dataModel.navigateUri = '/por/project/' + projectId + '/location/all?tab=progress_reports&navigation=notification');
    }
    else {
      this.analyticsLogger.logCloseoutNotification('CloseoutDocumentTopBanner');
      if (clientData && clientData.destination == ReduxConstants.CLOSEOUT_SUMMARY) {
        this.closeBanner().then(() => dataModel.navigateUri = '/projects/closeouts');
      }
      else {
        // TODO: does not redirect correctly to POR Location Documents
        // this.closeBanner().then(() => dataModel.navigateUri = '/por/location/' + locationId + '/project/' + projectId + '/closeout/' + closeoutId + "?navigation=notification")
        this.closeBanner().then(() => dataModel.navigateUri = '/por/project/' + projectId + '/location/all?tab=closeouts&navigation=notification');
      }
    }
  }

  render() {
    const { clientData, documentType } = this.props;
    const isProgressReport = documentType === 'progressReport';
    const isProjectTemplate = documentType === 'projectTemplate';
    const documentLabel = isProjectTemplate ? 'Project template' : (isProgressReport ? 'Progress Report' : 'Closeout Package');

    let bannerText;
    if (isProjectTemplate) {
      bannerText =
        <span className="closeout-banner__text">
          Your {documentLabel}&nbsp;
          <p className="closeout-banner__company-name">{this.props.closeoutableName}</p>
          &nbsp;is ready.&nbsp;
          <p onClick={this.navigateToDestination} className="closeout-banner__link">View in Project Types</p>
        </span>;
    }
    else if (!isProgressReport && clientData && clientData.destination == ReduxConstants.CLOSEOUT_SUMMARY) {
      bannerText =
        <span className="closeout-banner__text">
          Your {documentLabel} for&nbsp;
          <p className="closeout-banner__company-name">{this.props.closeoutableName}</p>
          &nbsp;is ready for you in the&nbsp;
          <p onClick={this.navigateToDestination} className="closeout-banner__link">Project Closeout Tab</p>
        </span>;
    } else {
      bannerText =
        <span className="closeout-banner__text">
          Your {documentLabel} for&nbsp;
          <p className="closeout-banner__company-name">{this.props.closeoutableName}</p>
          &nbsp;is ready for you in the&nbsp;
          <p onClick={this.navigateToDestination} className="closeout-banner__link">Plan of Record</p>
          <LocationsIconSolid fillColor="white"></LocationsIconSolid>
        </span>;
    }
    return (
      <span className={'closeout-banner' + (this.state.shown ? '' : ' closeout-banner--closing')}>
        { bannerText }
        <span className="closeout-banner__close" onClick={this.closeBanner}>&times;</span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/banners/CloseoutNotificationBanner/index.js